import { useQuery } from 'react-query';

import { getCustomCluster } from 'api/endPoints/getCustomCluster';
import { QueryKeys } from 'api/queryKeys';

import { CompareOptions } from 'components/Dashboards/ExcellenceApps/ClusterRCFAnalysis/CompareTo/CompareTo';

export const useQueryClustersDataBySearchWord = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['clustersDataBySearchWord', params],
        queryFn: () => getCustomCluster(params),
        enabled:
            Boolean(params.searchWord) &&
            Boolean(params.customerId) &&
            Boolean(params.idList) &&
            Boolean(params.compare),
        staleTime: 300000,
    });
};

export interface QueryParams {
    idList: number[];
    compare: CompareOptions | undefined;
    projectId: number | undefined;
    customerId: number | undefined;
    searchWord: string | undefined;
}

interface QueryResponse {
    clusterData: QueryResponse;
    clusterList: {
        clusterId: number;
        clusterName: string;
        completedDurationHigh: number | null;
        completedDurationTypical: number | null;
        completedOverrunDaysHigh: number | null;
        completedOverrunDaysTypical: number | null;
        completedOverrunRatioHigh: number | null;
        completedOverrunRatioTypical: number | null;
        fileMetaData: number | null;
        plannedDurationHigh: number | null;
        plannedDurationTypical: number | null;
    }[];
}
